/* ============================================================
   DRIPS EXOTICS — global storefront behaviour (theme)
   Mobile menu, scroll reveals, FAQ accordion, nav scroll state.
   (Header/footer markup is rendered by Liquid sections; cart is
   handled natively by the theme's cart-drawer.js.)
   ============================================================ */
(function () {
  function wireMenu() {
    var burger = document.querySelector('.nav-burger');
    var menu = document.querySelector('.mobile-menu');
    var scrim = document.querySelector('.scrim');
    if (!burger || !menu || !scrim) return;
    function toggle(open) {
      burger.classList.toggle('open', open);
      menu.classList.toggle('open', open);
      scrim.classList.toggle('open', open);
      menu.setAttribute('aria-hidden', !open);
    }
    burger.addEventListener('click', function () { toggle(!menu.classList.contains('open')); });
    scrim.addEventListener('click', function () { toggle(false); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { toggle(false); }); });
  }

  function wireReveals() {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function wireFAQ() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        if (item.classList.contains('open')) { item.classList.remove('open'); a.style.maxHeight = '0'; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  function wireNavScroll() {
    var nav = document.querySelector('.drips-nav');
    if (!nav) return;
    function on() {
      var s = window.scrollY > 30;
      nav.style.background = s ? 'color-mix(in srgb,var(--cream) 96%,transparent)' : 'color-mix(in srgb,var(--cream) 86%,transparent)';
      nav.style.boxShadow = s ? '0 6px 24px -18px rgba(43,34,38,.4)' : 'none';
    }
    on();
    window.addEventListener('scroll', on, { passive: true });
  }

  // Floating cart trigger → opens the SAME native drawer as the header cart icon,
  // and mirrors the header's count so both stay consistent.
  function wireFloatingCart() {
    var fc = document.querySelector('.drips-float-cart');
    if (!fc) return;
    fc.addEventListener('click', function () {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open(fc);
      else window.location.href = '/cart';
    });
    var bubble = document.getElementById('cart-icon-bubble');
    var fcCount = fc.querySelector('.fc-count');
    function sync() {
      var hc = bubble ? bubble.querySelector('.count') : null;
      var n = hc ? (parseInt(hc.textContent, 10) || 0) : 0;
      if (fcCount) { fcCount.textContent = n; fcCount.setAttribute('data-empty', n === 0 ? 'true' : 'false'); }
    }
    sync();
    if (bubble && window.MutationObserver) {
      new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() { wireMenu(); wireReveals(); wireFAQ(); wireNavScroll(); wireFloatingCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-run reveals/FAQ when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function () { wireReveals(); wireFAQ(); wireMenu(); });
})();
